import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";
import { fetchPull } from "../api";

interface CmsData {
  cultures: Record<string, any>;
  phases: Record<string, any>;
  completedPhases: Record<string, any>;
  highlights: Record<string, any>;
  problematics: Record<string, any>;
  models: Record<string, any>;
  profile: Record<string, any>;
  forms: Record<string, any>;
  collections: Record<string, any>;
  products: Record<string, any>;
}

interface StoryblokContextData {
  cmsData?: CmsData;
}

const StoryblokContext = createContext({} as StoryblokContextData);

export function StoryblokProvider(props: PropsWithChildren) {
  const { children } = props;

  const [cmsData, setCmsData] = useState<CmsData>();

  const fetchCmsData = async () => {
    try {
      const data = await fetchPull();

      localStorage.setItem("lastUpdate", new Date().getTime().toString());
      localStorage.setItem(
        "cmsData",
        JSON.stringify({
          cultures: data.cms.cultures,
          phases: data.cms.phases,
          completedPhases: data.cms.completedPhases,
          highlights: data.cms.highlights,
          problematics: data.cms.problematics,
          models: data.cms.models,
          profile: data.cms.profile,
          forms: data.cms.forms,
          collections: data.cms.collections,
          products: data.cms.products,
        })
      );

      setCmsData(data.cms);
    } catch (error) {
      console.error("Error fetching CMS data");
    }
  };

  useEffect(() => {
    fetchCmsData();
  }, []);

  return (
    <StoryblokContext.Provider value={{ cmsData }}>
      {children}
    </StoryblokContext.Provider>
  );
}

export function useStoryblok() {
  const context = useContext(StoryblokContext);
  return context;
}
